var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 32.5",
    style: {
      enableBackground: "new 0 0 30 32.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3,13.6L16.8,0.8l-0.2-0.2c-1-0.8-2.4-0.7-3.3,0.2L0.7,13.6l-0.2,0.2c-0.8,1-0.7,2.5,0.2,3.4L1,17.5 c1,0.8,2.4,0.7,3.3-0.2l8.2-8.5V30l0,0.3c0.1,1.2,1.2,2.2,2.5,2.2c1.4,0,2.5-1.1,2.5-2.5V8.8l8.2,8.5l0.2,0.2c1,0.8,2.4,0.7,3.3-0.2 C30.2,16.2,30.2,14.6,29.3,13.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLarge);
export default __webpack_public_path__ + "static/media/arrow-large.3f45403d41eb3ae97a414be54f486dc8.svg";
export { ForwardRef as ReactComponent };